<script setup>
  import {computed} from "vue";

  import {area as areaEnum} from "@pages/Records/Components/Result/Enums.js";
  import PagesRecordResultListClaims from "@pages/Records/Components/Result/ResultList/ListClaims.vue";
  import {MedInfoButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PagesRecordResultListChecks",
  });

  const props = defineProps({
    patientId: {
      type: String,
      required: true,
    },
    recordId: {
      type: String,
      required: true,
    },
    anchorPrefix: {
      type: String,
      required: true,
    },
    checks: {
      type: Array,
      required: true,
    },
    area: {
      type: String,
      default: areaEnum.prognostic,
    },
  });

  defineEmits(["open:shareDialog"]);

  /**
   * Returns an array of check.id from checks, which are communicated
   */
  const checksWithCommunicatedClaims = computed(() => {
    return props.checks
      .map((check) => {
        if (check.claims.some((claim) => claim.communicationdoc || claim.communicationpatient)) {
          return check.id;
        }
        return null;
      })
      .filter((claimId) => claimId !== null);
  });
</script>

<template>
  <div
    v-for="check in checks"
    :id="anchorPrefix + '-' + check.mc_check_id"
    :key="check.id"
    :class="[$attrs.class, 'border-1']"
    :data-test="getTestId('list-checks')"
  >
    <div class="flex items-center space-x-2 border-b-1 bg-gray-100 p-2 print:break-after-avoid-page">
      <h4
        :class="{
          'font-bold': checksWithCommunicatedClaims.includes(check.id),
          'font-semibold': !checksWithCommunicatedClaims.includes(check.id),
        }"
      >
        {{ check.checkname }}
      </h4>

      <MedInfoButton
        size="lg"
        side="top"
        class="print:hidden"
        aria-label="Check Information"
        :data-test="getTestId('list-checks-info-button')"
      >
        <div v-if="check?.claims[0]?.description" class="max-w-sm text-sm">
          <p class="mb-1 font-semibold">Check Information:</p>
          <!-- eslint-disable-next-line vue/no-v-html -- claim descriptions come from the Core service as rendered Blade output (AbstractCheckClaim::buildRedlightMouseOverClaimText with format "html") and contain markup such as <br> and links -->
          <div v-html="check.claims[0].description" />
        </div>
        <p v-else class="max-w-sm text-sm">Keine Check Information hinterlegt.</p>
      </MedInfoButton>
    </div>

    <!-- claims -->
    <PagesRecordResultListClaims
      :patient-id="patientId"
      :record-id="recordId"
      :mc-check-id="check.mc_check_id"
      :claims="check.claims"
      :area="area"
      :test-id="getTestId('list-checks')"
      @open:share-dialog="$emit('open:shareDialog')"
    />
  </div>
</template>
